import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  claimType: "REJECTED",
  programFilter: [],
  carrierFilter: [],
  groupFilter: [],
  assigneeFilter: [],
  dispositionFilter: [],

  selectedProgramIds: [],
  selectedCarrierIds: [],
  selectedGroupIds: [],
  selectedAssigneeIds: [],
  selectedDispositionIds: [],
  recentActivityOutcomeFilter: [],
  recentActivityReasonFilter: [],
  recentActivityOutcomesList: [],

  searchText: "",
  programFilterSearch: "",
  assigneeFilterSearch: "",
  groupFilterSearch: "",
  carrierFilterSearch: "",
  sorting: [],
  // Dropdown option lists
  programs: [],
  carrier: [],
  groups: [],
  assignees: [],
  programNameToIdMap: {},
  assigneeNameToIdMap: {},
  // Carrier/group relationship maps (persisted so filter sync
  // works correctly across navigation without extra refetches)
  carrierToGroupsMap: {},
  groupNumberToCarrierCode: {},
  groupNumberToCarrierDisplay: {},
};

const membersFilterSlice = createSlice({
  name: "membersFilters",
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters(state, action) {
      return {
        ...initialState,
        claimType: action.payload?.claimType || state.claimType,
      };
    },
  },
});

export const { setFilters, resetFilters } = membersFilterSlice.actions;
export default membersFilterSlice.reducer;
